<ng-container (mouseleave)="drop($event, this)">
  <div [class.drag-active]="!!drag">
    @for (address of getAddressArray(); track address; let fi = $index; let islast = $last) {
      <div class="draggable"
        (mousedown)="pick($event, address.config.property, fi)"
        (mousemove)="move($event, address.config.property)"
        (mouseup)="drop($event, address.config.property)"
        (touchmove)="move($event, address.config.property)"
        (touchstart)="pick($event, address.config.property, fi)"
        (touchend)="drop($event, address.config.property)"
        [ngClass]="{'wb-dragging': getPosY(address.config.property) }"
        [ngStyle]="{'transform': 'translate(' + getPosX(address.config.property) + 'px, ' + getPosY(address.config.property) + 'px)'}">
        <div class="wb-address-pane {{address.config.allowBrowserLocation ? 'allow-browser-location' : ''}}"
           [ngClass]="{
       'is-sortable': addressArray.length > 2,
       'wb-hasbefore-address-pane': !islast,
       'ng-autocomplete-error': $safeNavigationMigration(errors.getFieldErrors(address.config.property)?.length) > 0
     }">
          @if (address.config.showInlineLabel && address.config.label && (fi === 0 || islast)) {
            <span class="wb-summary-name wb-sortable-address-label"
              >
              {{ address.config.label | translate | ucFirst }}
            </span>
          }
          <app-address-field [ngClass]="(fi !== 0 && fi !== (addressArray.length-1) ? 'wb-stopover-pane' : '')"
            [config]="address.config"
            [form]="form"
            [sortableErrors]="errors"
            (openHelpModal)="toggleHelpModal($event.helpTitleTag, $event.helpTextTag, $event.type, $event.meta)"
          (checkWorkArea)="checkWorkAreaEmit($event)"></app-address-field>
          @if (fi !== 0 && fi !== (addressArray.length - 1)) {
            <div class="wb-drag-handle"
              (mousedown)="pick($event, address.config.property, fi)"
              (touchstart)="pick($event, address.config.property, fi)">
              <mat-icon>drag_indicator</mat-icon>
            </div>
          }
          @if ((fi !== 0 && fi !== (addressArray.length-1))) {
            <span (click)="removeDestination((fi-1))" class="wb-address-icon">
              <mat-icon>delete</mat-icon>
            </span>
          }
        </div>
      </div>
    }
    @if (allowStopOvers) {
      <div class="wb-add-stopover">
        <span (click)="addStopOver()">
          <mat-icon>add_circle_outline</mat-icon>
        </span>
        <span (click)="addStopOver()" class="wb-add-stopover-text">
          {{ 'add_stopover' | translate | ucFirst }}
        </span>
      </div>
    }
  </div>
</ng-container>
